// Address page accessibility - WCAG 1.3.1 compliance
// Announces to screen readers when addresses are added, updated, or deleted
(function() {
    const STORAGE_KEY = 'addressActionPending';
    let pageIsUnloading = false;
    
    // Track when page is navigating away
    window.addEventListener('beforeunload', function() {
        pageIsUnloading = true;
    });
    
    function announceAddressAction() {
        const addressSection = document.querySelector('[data-section-type="addresses"]');
        const announcement = document.getElementById('addresses-status-announcement');
        
        if (!addressSection || !announcement) return;
        
        const pendingAction = sessionStorage.getItem(STORAGE_KEY);
        if (!pendingAction) return;
        
        // Clear the storage immediately to prevent duplicate announcements
        sessionStorage.removeItem(STORAGE_KEY);
        
        let message = '';
        switch (pendingAction) {
            case 'add':
                message = addressSection.dataset.addressAddedMessage || 'New address has been added successfully.';
                break;
            case 'update':
                message = addressSection.dataset.addressUpdatedMessage || 'Address has been updated successfully.';
                break;
            case 'delete':
                message = addressSection.dataset.addressDeletedMessage || 'Address has been deleted successfully.';
                break;
        }
        
        if (message) {
            // Small delay to ensure page is fully loaded before announcement
            setTimeout(function() {
                announcement.textContent = message;
                // Move focus to the announcement for better screen reader support
                announcement.setAttribute('tabindex', '-1');
                announcement.focus();
            }, 500);
        }
    }
    
    function setupAddressFormTracking() {
        const addressSection = document.querySelector('[data-section-type="addresses"]');
        if (!addressSection) return;
        
        // Track form submissions for add/update actions
        const forms = addressSection.querySelectorAll('form[action*="/account/addresses"]');
        forms.forEach(function(form) {
            form.addEventListener('submit', function() {
                // Determine if this is an add or update action
                // New address form has id="address_form_new", edit forms have specific IDs
                const isNewAddress = form.id === 'address_form_new';
                sessionStorage.setItem(STORAGE_KEY, isNewAddress ? 'add' : 'update');
            });
        });
        
        // Track delete button clicks
        // Use capture phase to run before the theme's click handler
        const deleteButtons = addressSection.querySelectorAll('[data-remove]');
        deleteButtons.forEach(function(button) {
            button.addEventListener('click', function() {
                // Set the action - if user confirms, page will reload with this set
                sessionStorage.setItem(STORAGE_KEY, 'delete');
                
                // Clear the storage after a delay if page hasn't started unloading
                // This handles the case when user cancels the confirm dialog
                // The confirm() dialog blocks execution, so this timeout fires after
                // the user responds to the dialog
                setTimeout(function() {
                    if (!pageIsUnloading) {
                        sessionStorage.removeItem(STORAGE_KEY);
                    }
                }, 100);
            });
        });
    }
    
    // Run on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            announceAddressAction();
            setupAddressFormTracking();
        });
    } else {
        announceAddressAction();
        setupAddressFormTracking();
    }
})();

$(document).ready(function () {

    setTimeout(function () {
        $('.rebuy-cart__flyout-content ul.rebuy-cart__flyout-items[role="group"]').attr("role", "list");

         $('.rebuy-cart__flyout-item-info > a.rebuy-cart__flyout-item-product-title').each(function () {
            // Wrap this anchor with <h5>
            $(this).removeAttr('role').removeAttr('aria-level');
            $(this).wrap('<h5 class="rebuy-cart__item-heading"></h5>');
        });

        $('#1763669626820_350644915463232').attr('title', 'Dental Professionals Form');

        $('.text-columns-with-images__grid .text-columns-with-images__item-heading').each(function () {
            if ($(this).is('h4')) {
            $(this).replaceWith('<h2 class="' + this.className + '" style="' + this.getAttribute("style") + '">' + $(this).html() + '</h2>');
            }
        });

        const $titlePrimaryTitle = $('.rebuy-widget-content h4.primary-title');
        if ($titlePrimaryTitle.length && $titlePrimaryTitle.is('h4')) {
            $titlePrimaryTitle.replaceWith(
            '<h3 class="' + $titlePrimaryTitle.attr('class') + '">' + $titlePrimaryTitle.html() + '</h3>'
            );
        }

        $('.needsclick img').attr('alt', 'Launch Party Signup Form Logo');
        $('.rte__iframe iframe').attr('title', 'Video: Overview of Ollie Fluoride product');
        
        $('#shopify-section-template--20068264902887__1659521440fcda1607 iframe').attr('title', 'Form: Ollie for Dental Professionals');   
        
        const $titleTypography = $('h3.Typography_header-small__F94WP');
        if ($titleTypography.length && $titleTypography.is('h3')) {
            $titleTypography.replaceWith(
            '<h2 class="' + $titleTypography.attr('class') + '">' + $titleTypography.html() + '</h2>'
            );
        }

        const $titleAccountHeading = $('.account__header .account__heading');
        if ($titleAccountHeading.length && $titleAccountHeading.is('h1')) {
            $titleAccountHeading.replaceWith(
            '<h2 class="' + $titleAccountHeading.attr('class') + '">' + $titleAccountHeading.html() + '</h2>'
            );
        }

        $('p.account__subheading').replaceWith(function () {
            return $('<h3>', {
                class: this.className,
                html: $(this).html()
            });
        });

        $('div._1fragem32 span').replaceWith(function () {
            return $('<h1>', {
                class: this.className,
                html: $(this).html()
            });
        });

        $('#chat-window').attr('aria-label', 'Live chat support');        
        


    }, 3000);

    setTimeout(function () { 
        $('dt[data-role="instructions"]').wrap('<dl></dl>');
        $('label[role="radio"]').removeAttr('role aria-checked tabindex data-role');

    }, 5000);

    const $title = $('.featured-product__details .product__title');
    if ($title.length && $title.is('h1')) {
        $title.replaceWith(
        '<h2 class="' + $title.attr('class') + '">' + $title.html() + '</h2>'
        );
    }

    const $subheading = $('.image-with-text__subheading h6');
    if ($subheading.length) {
        $subheading.replaceWith(
        '<h3 class="h3-heading">' + $subheading.html() + '</h3>'
        );
    }

    $('.collection__products .product-item h4.product-item__product-title').each(function () {
        const newH3 = $('<h3>', {
            class: this.className,
            html: $(this).html()
        });

        $(this).replaceWith(newH3);
    });

   const $titleBlog = $('.blog__header .blog__heading');
    if ($titleBlog.length && $titleBlog.is('h1')) {
        $titleBlog.replaceWith(
        '<h2 class="' + $titleBlog.attr('class') + '">' + $titleBlog.html() + '</h2>'
        );
    }

    const $titleArticle = $('.article__header .article__heading');
    if ($titleArticle.length && $titleArticle.is('h1')) {
        $titleArticle.replaceWith(
        '<h2 class="' + $titleArticle.attr('class') + '">' + $titleArticle.html() + '</h2>'
        );
    }

    const $titleArticleDate = $('.article__header .article__date');
    if ($titleArticleDate.length && $titleArticleDate.is('p')) {
        $titleArticleDate.replaceWith(
        '<h3 class="' + $titleArticleDate.attr('class') + '">' + $titleArticleDate.html() + '</h2>'
        );
    }

    const $titlePage = $('.page__header .page__heading');
    if ($titlePage.length && $titlePage.is('h1')) {
        $titlePage.replaceWith(
        '<h2 class="' + $titlePage.attr('class') + '">' + $titlePage.html() + '</h2>'
        );
    }

    const $titleH4 = $('h4.ff-heading');
    if ($titleH4.length && $titleH4.is('h4')) {
        $titleH4.replaceWith(
        '<h2 class="' + $titleH4.attr('class') + '">' + $titleH4.html() + '</h2>'
        );
    }

    $('.featured-collection__slide .product-item h4.product-item__product-title').each(function () {
        const newH3 = $('<h3>', {
            class: this.className,
            html: $(this).html()
        });

        $(this).replaceWith(newH3);
    });

    const $titleProduct = $('.product .product__title');
    if ($titleProduct.length && $titleProduct.is('h1')) {
        $titleProduct.replaceWith(
        '<h2 class="' + $titleProduct.attr('class') + '">' + $titleProduct.html() + '</h2>'
        );
    }


    $('.product__description-content h5').each(function () {
        const newH4 = $('<h4>', {
            class: this.className,
            html: $(this).html()
        });

        $(this).replaceWith(newH4);
    });

    const $titleProductH4 = $('#shopify-section-template--20068264706279__rich_text_et4BYb h4');
    if ($titleProductH4.length && $titleProductH4.is('h4')) {
        $titleProductH4.replaceWith(
        '<h2 class="' + $titleProductH4.attr('class') + '">' + $titleProductH4.html() + '</h2>'
        );
    }


    $('h4.testimonials__item-heading').each(function () {
        const newH2 = $('<h2>', {
            class: this.className,
            html: $(this).html()
        });
        $(this).replaceWith(newH2);
    });


     $('.account__table td[scope="row"]').removeAttr('scope');

     setTimeout(function () {        
        $('.rebuy-checkbox-label').attr('for', 'rebuy-addon-checkbox');
        $('.rebuy-addon__item-checkbox input[type="checkbox"]').attr('id', 'rebuy-addon-checkbox');  
        
        $('.SubscriptionBody .sc-b9126cac-1').each(function () {
            const $product = $(this);

            // Get product name (first product title text)
            const productName = $product
                .find('.Typography_text-medium__cKI_Y.Typography_margin-reset__hP10F')
                .first()
                .text()
                .trim();

            // Update Edit button aria-label
            $product.find('button[aria-label="Edit"]').attr(
                'aria-label',
                'Edit ' + productName
            );

            // Update Increase quantity button
            $product.find('button[aria-label="Increase quantity"]').attr({
                'aria-label': 'Increase quantity of product ' + productName,
                'type': 'button',
                'tabindex' : '0',
                'role': 'button'
            });

            // Update Decrease quantity button
            $product.find('button[aria-label="Decrease quantity"]').attr({
                'aria-label' : 'Decrease quantity of product ' + productName,
                'type': 'button',
                'tabindex' : '0',
                'role': 'button'
            });
        });

         // ---- ---- //

        $('[data-is-required="1"]').each(function () {
            $(this)
            .find('input, select, textarea')
            .attr('aria-required', 'true')
            .attr('required', true);
        });

        $('[data-type="radio"][data-is-required="1"], [data-type="check-box"][data-is-required="1"]').attr('aria-required', 'true');

        $('#1765930829346_336404858570450 form').on('submit', function (e) {
            let errors = [];
            const $form = $(this);

            $form.find('[aria-required="true"], [required]').each(function () {
                const $field = $(this);
                const value = $.trim($field.val());
                const labelText =
                $('label[for="' + $field.attr('id') + '"]').text() || 'This field';

                // if (!value) {
                //     $field
                //         .attr('aria-invalid', 'true')
                //         .attr('aria-describedby', 'email-error');

                //     $('#email-error').show();
                // }

                if (!value) {
                errors.push(labelText + ' is required.');
                $field.attr('aria-invalid', 'true');
                } else {
                $field.removeAttr('aria-invalid');
                }
            });

            if (errors.length > 0) {
                e.preventDefault();

                const errorMessage = errors.join(' ');

                const $errorBox = $form.find('.form-errors');
                $errorBox.text(errorMessage);

                // Move screen reader focus
                $errorBox.focus();
            }
        });

    

        $('input, select, textarea').on('input change', function () {
            $(this)
                .removeAttr('aria-invalid')
                .removeAttr('aria-describedby');

            $('.form-errors').text('');
            $(this).siblings('.error-message').hide();
        });

        // ---- ---- //
        
        $('#chat-button').attr({
            title: 'Open live chat',
            'aria-label': 'Open live chat',
            role: 'button',
            tabindex: '0'
            }).on('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                $(this).click();
            }
        });

        // ---- ---- //

        $('.sc-4b34317c-1.dtdVCr').eq(2).find('button[aria-label="Order Now"]').attr('aria-label', 'Get Now');

        $('.nextFrost:visible').find('.tBJ.dyH.iFc.yTZ.erh.zDA.IZT.swG').attr('aria-live', 'assertive').attr('role', 'alert');


        
     }, 5000);

     // ---- ---- //

     $('.payment-icons__icon svg[aria-labelledby]').each(function () {
        const val = $(this).attr('aria-labelledby');
        $(this).attr('aria-label', 'Icon: ' + val);
    });

    $('.header__right a').filter(':eq(0), :eq(2)').attr('role', 'button');

    $('.footer__header').attr('aria-expanded', 'false');
    $(document).on('click', '.footer__header', function () {

        if ($(this).hasClass('open')) {
            $(this).attr('aria-expanded', 'true');
        } else {
            $(this).attr('aria-expanded', 'false');
        }
    });

    // $('.product__color-chips').attr('role', 'radiogroup');

    $('.social-proof__content').attr({
        'role': 'region',
        'aria-live': 'polite',
        'aria-label': 'About Us Slider',
        'aria-roledescription': 'carousel',

    });    

     setTimeout(function () {
        $('.social-proof__slider-wrapper .flickity-slider .social-proof__slide').each(function() {
            $(this).attr('role', 'group');
        });
    }, 3000);    

    $('.blog__article-item .blog__article-image img').attr('tabindex', 0);

    $('.account__main .account__table').attr('aria-label', 'Order List Table');
    $('.account__breadcrumbs .breadcrumbs').attr({
        'role': 'navigation',
        'aria-label': 'breadcrumb'
    });
    $('.breadcrumbs').find('li').last().attr('aria-current', 'page');
    $('.addresses__new button').removeAttr('aria-expanded');
    $('.fs-body-small li:first-child button').attr('aria-label', 'Edit Address');
    $('.fs-body-small li:last-child button').attr('aria-label', 'Delete Address');

    // ---- ---- //

    $('.addresses__modal').attr({
        'role': 'dialog',
        'aria-label': 'Add new address',
        'aria-modal': 'true'
    });

    // ---- ---- //

    setTimeout(function () {
        $('.quotes').removeAttr('tabindex');

        $('.why-ollie-column .feature-box').each(function() {
            $(this).find('.feature-icon img').attr('role', 'presentation');
        });

    }, 3000); 

    // ---- ---- //

    $('#shopify-section-template--20068265066727__main .page__inner p img').attr('alt', 'Certificate of Analysis for Clean Mint Toothpaste');

    // ---- ---- //

    $('.text-columns-with-images__item-image img').each(function () {
        if (!$(this).is('[tabindex]')) {
            $(this).attr('tabindex', '0');
        }
    });

    // ---- ---- //

    $('form[action="/cart"] .cart-item__remove').attr({
        role: 'button',
        tabindex: '0',
        'aria-label': 'Remove cart item'
    });

    // ---- ---- //

    $('form[action="/cart"] .cart__item-button--minus').attr({
        'aria-label': 'Subtract product quantity'
    });

    // ---- ---- //

    $('form[action="/cart"] .cart__item-button--plus').attr({
        'aria-label': 'Add product quantity'
    });

    // ---- ---- //
    
    $('.product-item__image').attr('tabindex', '0');

    // ---- ---- //

    $('.featured-product__media-container .media img').attr({
        'tabindex': '0',
        'aria-label': 'Product image with zoom view'
    });

    // ---- ---- //

    $('.collection__products .product-item').each(function () {
    const $product = $(this);

    // Get product name from h3
    const productName = $product
        .find('h3.product-item__product-title')
        .text()
        .trim();

    // Add aria-label to Add to Cart button
    $product
        .find('button.product-item__quick-add-button')
        .attr('aria-label', 'Add to cart product: ' + productName);
    });

    // ---- ---- //


    $(document).on('click', '.product-item__quick-add-button', function () {
        const checkModalInterval = setInterval(function () {
            const $modal = $('.quick-add-modal__inner');

            // Modal exists and is visible
            if ($modal.length && $modal.is(':visible')) {
            const $title = $modal.find('.product__title').first();

            if ($title.length) {
                // Ensure title has an ID
                if (!$title.attr('id')) {
                $title.attr('id', 'quick-add-modal-title');
                }

                // Apply ARIA attributes
                $modal.attr({
                role: 'dialog',
                'aria-modal': 'true',
                'aria-labelledby': $title.attr('id')
                });

                clearInterval(checkModalInterval);
            }
            }
        }, 50); // check every 50ms
    });


    // ---- ---- //

    $('.article__share .article__share-icons').removeAttr('aria-label');

    // ---- ---- //
    
    const $shareIcons = $('.article__share-icons .share-icons');

    // Remove incorrect ARIA/menu roles
    $shareIcons.removeAttr('role aria-haspopup aria-expanded');

    // Ensure container is not treated as a menu
    $shareIcons.attr('role', 'group');

    // Ensure links are clean links
    $shareIcons.find('a').each(function () {
        $(this)
        .removeAttr('role aria-haspopup aria-expanded')
        .attr('role', 'link');
    });

    // ---- ---- //

     $('#contact-ContactFormEmail').attr('aria-required', 'true');

    // ---- ---- //     

    



    // ---- ---- //  


    $('.product__chip').on('keydown', function (e) {
    const $chips = $('.product__chip');
    let index = $chips.index(this);

    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        index = (index + 1) % $chips.length;
        $chips.eq(index).focus().click();
        e.preventDefault();
    }

    if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        index = (index - 1 + $chips.length) % $chips.length;
        $chips.eq(index).focus().click();
        e.preventDefault();
    }
    });



    
   
    const $chipsContainer = $('.product__color-chips');
    const $chips = $chipsContainer.find('.product__chip');

    $chipsContainer.attr('role', 'radiogroup');

    $chips.each(function () {
        const isSelected = $(this).hasClass('selected');

        $(this).attr({
        role: 'radio',
        'aria-checked': isSelected ? 'true' : 'false',
        tabindex: isSelected ? '0' : '-1'
        });
    });


  
   
    let isKeyboardUser = false;

    // Detect keyboard navigation
    $(document).on('keydown', function (e) {
    if (e.key === 'Tab') {
        isKeyboardUser = true;
    }
    });

    // Detect mouse interaction
    $(document).on('mousedown', function () {
    isKeyboardUser = false;
    });

    // Apply focus style only for keyboard users
    $('.product-thumbnails__item-link')
    .on('focus', function () {
        if (isKeyboardUser) {
        $(this).addClass('keyboard-focus-visible');
        }
    })
    .on('blur', function () {
        $(this).removeClass('keyboard-focus-visible');
    });



    $('.product-thumbnails__item-link').attr('aria-selected', 'false');

    $('.product-thumbnails__item-link').on('click', function () {
    $('.product-thumbnails__item-link')
        .removeClass('active')
        .attr('aria-selected', 'false');

    $(this)
        .addClass('active')
        .attr('aria-selected', 'true');
    });

    $(".header__icon-touch--account").attr('role', 'button');


    
    $('a.Wk9.xQ4.CCY.czT.eEj.kVc.uCz').css('text-decoration', 'underline').attr('style', function (i, style) {
        return (style || '') + '; text-decoration: underline !important;';
    });




    
    $('.product-item__image[tabindex="0"]').attr('tabindex', '-1');  
    $('.product-item__product-title a, .product-item__image-link').attr('tabindex', '0');
    $('.product-item__quick-add-button').attr('tabindex', '0');

    $('<style>')
    .prop('type', 'text/css')
    .html(`
        .product-item a:focus-visible,
        .product-item button:focus-visible {
        outline: 3px solid #000 !important;
        outline-offset: 3px;
        }
    `).appendTo('head');

    $(document).on('keydown', '.product-item', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            if (!$(e.target).is('a, button')) {
            e.preventDefault();
            }
        }
    });


    

     

    




  });

   $(document).on('keydown', '.product__chip[role="radio"]', function (e) {
        const $chips = $(this).closest('[role="radiogroup"]').find('[role="radio"]');
        let index = $chips.index(this);

        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            index = (index + 1) % $chips.length;
            selectChip($chips.eq(index));
            e.preventDefault();
        }

        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            index = (index - 1 + $chips.length) % $chips.length;
            selectChip($chips.eq(index));
            e.preventDefault();
        }

        if (e.key === ' ' || e.key === 'Enter') {
            selectChip($(this));
            e.preventDefault();
        }
    });


    function selectChip($chip) {
        const $group = $chip.closest('[role="radiogroup"]');
        const $chips = $group.find('[role="radio"]');

        // Reset all radios
        $chips
            .attr({
            'aria-checked': 'false',
            tabindex: '-1'
            })
            .removeClass('selected');

        // Activate selected radio
        $chip
            .attr({
            'aria-checked': 'true',
            tabindex: '0'
            })
            .addClass('selected')
            .focus();
    }

    // ---- ---- //

document.addEventListener("DOMContentLoaded", function () {
    const el = document.querySelector('.rebuy-cart__flyout-content ul.rebuy-cart__flyout-items[role="group"]');
    if (el) {
        el.setAttribute("role", "list");
    }

    // Update aria-checked on swatch and chip radio buttons when clicked
    document.addEventListener('click', function(e) {
        const button = e.target.closest('[role="radio"]');
        if (button) {
            const radioGroup = button.closest('[role="radiogroup"]');
            if (radioGroup) {
                // Set all buttons in this group to aria-checked="false"
                radioGroup.querySelectorAll('[role="radio"]').forEach(function(btn) {
                    btn.setAttribute('aria-checked', 'false');
                });
                // Set the clicked button to aria-checked="true"
                button.setAttribute('aria-checked', 'true');
            }
        }
    });

    // Update aria-selected on lightbox tab controls when clicked
    document.addEventListener('click', function(e) {
        // Handle tab click
        const tab = e.target.closest('.lightbox__image-nav-image[role="tab"]');
        if (tab) {
            const tablist = tab.closest('[role="tablist"]');
            if (tablist) {
                tablist.querySelectorAll('[role="tab"]').forEach(function(t) {
                    t.setAttribute('aria-selected', 'false');
                });
                tab.setAttribute('aria-selected', 'true');
            }
        }

        // Handle prev/next button clicks - update tabs based on visible slide
        const prevBtn = e.target.closest('.lightbox__button-previous');
        const nextBtn = e.target.closest('.lightbox__button-next');
        if (prevBtn || nextBtn) {
            const lightbox = e.target.closest('.lightbox');
            if (lightbox) {
                // Use setTimeout to allow the slide transition to complete
                setTimeout(function() {
                    updateLightboxTabSelection(lightbox);
                }, 100);
            }
        }
    });

    // Function to update lightbox tab selection based on current slide
    function updateLightboxTabSelection(lightbox) {
        const tabs = lightbox.querySelectorAll('.lightbox__image-nav-image[role="tab"]');
        const slides = lightbox.querySelectorAll('.lightbox__image[data-slide]');
        
        // Find the currently active/visible slide by checking for 'is-selected' class or similar
        slides.forEach(function(slide, index) {
            if (slide.classList.contains('is-selected') || slide.classList.contains('active')) {
                tabs.forEach(function(tab) {
                    tab.setAttribute('aria-selected', 'false');
                });
                if (tabs[index]) {
                    tabs[index].setAttribute('aria-selected', 'true');
                }
            }
        });
    }

    // Also observe for programmatic slide changes using MutationObserver
    const lightboxes = document.querySelectorAll('.lightbox');
    lightboxes.forEach(function(lightbox) {
        const slider = lightbox.querySelector('.lightbox__images');
        if (slider) {
            const observer = new MutationObserver(function() {
                updateLightboxTabSelection(lightbox);
            });
            observer.observe(slider, { attributes: true, subtree: true, attributeFilter: ['class'] });
        }
    });
    $('[src*="Image_80x.svg"]').attr("alt","5 Star, 50,000+ Happy Smiles");
});

